import Cookies from 'js-cookie'

// Sends the locale to the service worker
const postLocaleMessage = (locale) => {
  if (!navigator.serviceWorker || !navigator.serviceWorker.controller) return Promise.resolve()

  return new Promise((resolve, reject) => {
    const channel = new MessageChannel()

    channel.port1.onmessage = ({ data }) => (data.error ? reject(data.error) : resolve(data))
    navigator.serviceWorker.controller.postMessage({ locale }, [channel.port2])
  })
}

export default function ({ app }) {
  // Set a cookie on locale change
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    Cookies.set('i18n_locale', newLocale, { expires: 365 })

    // Let the service worker know the locale has changed
    postLocaleMessage(newLocale + '-CA')
  }

  if ('serviceWorker' in navigator) {
    // For initial service worker registration
    navigator.serviceWorker.addEventListener('message', (event) => {
      // wait for the service worker to activate then tell it the client locale
      if (event.data.activated === true) postLocaleMessage(app.i18n.locale + '-CA')
    })
    // for vists after serviceworker registration
    app.router.onReady(() => postLocaleMessage(app.i18n.locale + '-CA'))
  }
}
